<template>
    <div>
        <div class="form-group">
            <div class="row no-gutter">
                <div class="col-md-5">
                    <label>How did you hear about the program?</label>
                </div>
                <div class="col-md-7" v-bind:class="{'has-error': errors.has('how_you_heard')}">
                    <select class="form-control"
                        name="how_you_heard"
                        v-model="how_you_heard"
                        data-vv-name="how_you_heard"
                        v-validate="'required'"
                    >
                        <option value="">-- Please select an option --</option>
                        <option value="email">Email</option>
                        <option value="event">Event</option>
                        <option value="news">News</option>
                        <option value="facebook">Facebook</option>
                        <option value="friend">From a Friend</option>
                        <option value="mailer">Mailer</option>
                        <option value="website">Website</option>
                        <option value="other">Other</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row no-gutter">
                <div class="col-md-5">
                    <label>I am buying as a:</label>
                </div>
                <div class="col-md-7">
                    <div class="checkbox-item">
                        <input type="checkbox" class="check-style" id="buying_as_season" v-model="buying_as" value="season">
                        <label for="buying_as_season">Season Ticket Member</label>
                    </div>
                    <div class="checkbox-item">
                        <input type="checkbox" class="check-style" id="buying_as_fan" v-model="buying_as" value="fan">
                        <label for="buying_as_fan">Fan</label>
                    </div>
                    <div class="checkbox-item">
                        <input type="checkbox" class="check-style" id="buying_as_gift" v-model="buying_as" value="gift">
                        <label for="buying_as_gift">Gift</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'marketing-information',
        data: function () {
            return this.getDefaultData();
        },
        computed: {
            // errors: {}
        },
        methods: {
            getDefaultData: function () {
                // to provide original defaults only once
                return Object.assign({},
                    {
                        how_you_heard: '',
                        buying_as: []
                    },
                    this.$store.getters.marketing
                );
            }
        }
    }
</script>


// WEBPACK FOOTER //
// MarketingInformation.vue?5cac072e